import type {HelpFile} from '../../types/help'
import {AuthorityViolationsSectionTestIds} from '../../../testids/AuthorityViolationsSectionTestIds'

export const authorityViolationsSectionHelp: HelpFile = {
  docPage: '/docs/admin/multi-source-sync',
  texts: {
    [AuthorityViolationsSectionTestIds.sectionAuthorityViolations]:
      'Attribute writes the inbound run skipped because another target system already owns the value (first-writer-wins, Spec §2.3). Each row names the entity, attribute, current owner, and the system that attempted the write. To let this run win, release authority on the affected attributes — manually per attribute, in bulk via the Sources card, or by transferring authority.',
    [AuthorityViolationsSectionTestIds.authorityViolationsList]:
      'One row per skipped attribute write. Click an entity name to open its detail page and inspect the affected attribute.',
    [AuthorityViolationsSectionTestIds.authorityViolationsTruncated]:
      'Only the first 100 violations are listed. To review them all, open the Identity / Party list and filter by attribute authority owner — the linked filter pre-fills the target system from this run.',
  },
}
